import { render, staticRenderFns } from "./Signup-by-IIn-phone-confirm.vue?vue&type=template&id=7cf4428a"
import script from "./Signup-by-IIn-phone-confirm.vue?vue&type=script&lang=js"
export * from "./Signup-by-IIn-phone-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports